import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Styles from '../Style/Common.module.css';
import BtnStyle from '../Style/Button.module.css';
import parse from 'html-react-parser';  
//icon
import { RxArrowTopRight } from "react-icons/rx";
//image api
import constants from "../../services/constants";
const TQsustainability = ({ data }) =>{
  return(
    <div className={Styles.sustainabilityBlock}>
      <img src={`${constants.Image_BASE_URL}${data?.image[0].fileName}`} alt={data?.title} />
      <div className={Styles.content} data-aos="fade-up" data-aos-delay="200">
          <h3 data-aos="fade-up" data-aos-delay="500">{data?.title}</h3>
          <p data-aos="fade-up" data-aos-delay="700">{parse(data?.description)}</p>
          {/* <Link to={data?.link} className={BtnStyle.roundBtn + ' ' + BtnStyle.RoundRedWhite} data-aos="fade-up" data-aos-delay="900">
              <RxArrowTopRight />
          </Link> */}
      </div>
    </div>
  )
}

export default TQsustainability;